import React, { useEffect, useState } from "react";
import { testingDomains } from "../utils/sharedDatasets";
import NotFoundPage from "../pages/404";

const NavigateToParentSite = () => {
  const [redirectPath, setRedirectPath] = useState("");

  // console.debug("NavigateToParentSite loading >>");

  useEffect(() => {
    const url = new URL(window.location);
    url.searchParams.set("__xbypass", "1");

    //console.debug("redirectPath url", url);

    const includesTestingInstance = testingDomains.some((testInstance) =>
      url.host.includes(testInstance)
    );

    if (!includesTestingInstance) setRedirectPath(url?.href);
  }, []);

  // console.debug("redirectPath", redirectPath);

  return <>{redirectPath && <NotFoundPage />}</>;
};

export default NavigateToParentSite;
